// Tiny event-bus helpers for permission state changes.
//
// `useEffectivePermissions` reads the cached /me payload and snapshots it on
// mount. Anything that mutates the *current user's* permissions
// (self-edit on /me, role edited by an admin whose role it is, etc.) should
// call `notifyPermissionsChanged()` after re-fetching /me so the sidebar
// and any <PermissionGuard> re-render without a full reload.
//
// Centralising the event name here means consumers don't have to know the
// magic string and a future removal is a one-file change.

const PERMISSIONS_UPDATED_EVENT = 'mdg:permissions-updated'

/** Fire the global "permissions changed" event. */
export function notifyPermissionsChanged() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(PERMISSIONS_UPDATED_EVENT))
}

export { PERMISSIONS_UPDATED_EVENT }
